import _taggedTemplateLiteral from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";

var _templateObject, _templateObject2;

import { oneLineTrim } from 'common-tags';
import { challenges } from './challenge';
import { member123, member678 } from './member';
export var feedActivities = [{
  __typename: 'PublicResponse',
  id: '1',
  member: member123,
  createdAt: '2022-04-07T14:18:47.473Z',
  responses: [{
    question: {
      html: 'What kind of super power do you have?',
      text: 'What kind of super power do you have?'
    },
    answer: '123',
    answerType: 'Text'
  }],
  stage: {
    id: '123',
    __typename: 'QuestionsStage',
    challenge: challenges[0]
  },
  currentUserLike: {
    id: '456'
  },
  likes: {
    totalCount: 1
  }
}, {
  __typename: 'PublicResponse',
  id: '1',
  member: member123,
  createdAt: '2022-04-07T14:18:47.473Z',
  responses: [{
    question: {
      html: 'Upload a nice video',
      text: 'Upload a nice video'
    },
    answer: 'http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4',
    answerType: 'ConvertedVideo'
  }],
  stage: {
    id: '123',
    __typename: 'QuestionsStage',
    challenge: challenges[1]
  },
  currentUserLike: {
    id: '456'
  },
  likes: {
    totalCount: 1
  }
}, {
  __typename: 'PublicResponse',
  id: '1',
  member: member123,
  createdAt: '2022-04-07T14:18:47.473Z',
  responses: [{
    question: {
      html: 'Upload a nice video',
      text: 'Upload a nice video'
    },
    answer: 'http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4',
    answerType: 'RawVideo'
  }],
  stage: {
    id: '123',
    __typename: 'QuestionsStage',
    challenge: challenges[2]
  },
  currentUserLike: {
    id: '456'
  },
  likes: {
    totalCount: 1
  }
}, {
  __typename: 'PublicResponse',
  id: '2',
  member: member678,
  createdAt: '2022-04-07T14:19:47.473Z',
  responses: [{
    question: {
      html: 'Show us your superhero costume!',
      text: 'Show us your superhero costume!'
    },
    answer: 'https://static.influitive.com/influitiveimages/hq/attachments/banner/2622.?1616189031',
    answerType: 'Image'
  }],
  stage: {
    id: '234',
    __typename: 'ImageUploadStage',
    challenge: challenges[3]
  },
  currentUserLike: null,
  likes: {
    totalCount: 0
  }
}, {
  __typename: 'Topic',
  id: '3',
  author: member678,
  posts: {
    edges: [{
      node: {
        latestVersion: {
          body: '<h3>oneverylongwordwithnospacestestingifitwrapstonewlineorgetstruncatedatalloritjustbreaks</h3>'
        }
      }
    }]
  },
  createdAt: '2021-04-07T14:18:47.473Z',
  title: 'Top 10 best superhero fights',
  slug: '1er3473yqefiuf'
}, {
  id: '4',
  __typename: 'Post',
  author: member678,
  postNumber: 1,
  latestVersion: {
    body: oneLineTrim(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n        <p><img src=\"https://db_b5922dfb_1dbc_4ffc_a6da_2d595f0ef66a.influitives.com/forum/images/emoji/twitter/apple.png?v=9\" title=\":apple:\" class=\"emoji\" alt=\":apple:\">Pembrokeshire and Cardiganshire are adjoining historical agricultural counties in South West Wales. Welsh Corgis were cattle herding dogs; the type of herding dog referred to as \"heelers\",\n        meaning that they would nip at the heels of the larger animals to keep them on the move. The combination of their low height off the ground and innate agility of Welsh Corgis would allow\n        them to avoid the hooves of cattle. The term \"Corgi\" means either cur dog or dwarf dog (cor = dwarf, gi = lenitive of ci, dog) in the Welsh language, which was not intended as an insult to\n        the dog's size, rather as a purely descriptive term. Different tales have been told of the Corgi's origin: some believe that the two modern breeds evolved from a shared ancestry, while\n        others attribute the import of the Pembroke Welsh Corgi to Flemish weavers starting around the 10th century. Further theories on the origin of the Pembroke variety suggest that they may\n        have originated from central European herding breeds from the area around modern Germany. Depending on the time period when these dogs were imported to Wales, they could have been either\n        Deutsche Bracken, or Dachshund. The Cardigan Welsh Corgi has been attributed to the influences of Nordic settlers in the region. Dogs of similar dimensions exist in modern Scandinavia,\n        called the Swedish Vallhund, and it is claimed by some historians that these two breeds share a common ancestor.  In the late 19th century, farmers in began to switch from cattle to sheep\n        but the corgi is not suited for working sheep. Similarities between the Welsh Corgis have been attributed to cross-breeding between the two, or simply selected breeding from those who wished\n        to have the Cardigan variety appear closer in nature to the Pembroke.</p>\n      "]))),
    createdAt: '2021-04-07T14:02:24.907Z'
  },
  topic: {
    id: '123',
    title: 'Types of Corgis',
    slug: 'corgs'
  }
}, {
  __typename: 'PublicResponse',
  id: '5',
  member: member678,
  createdAt: '2022-04-07T14:20:47.473Z',
  responses: [{
    question: {
      html: 'Who is the worst super villian you have fought? Who is the worst super villian you have fought? Who is the worst super villian you have fought?',
      text: 'Who is the worst super villian you have fought? Who is the worst super villian you have fought? Who is the worst super villian you have fought?'
    },
    answer: oneLineTrim(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n          There are too many to choose from! Magneto, Sabertooth, Apocalypse, Mystigue, Mastermind, Stryfe, Thanos,\n          Galactus, Doctor Doom, Loki, Red Skull, Green Golbin, Ultron, Abyss, Challenger, Chemistro, Commander, Blob,\n          Ammo, Calypso, Basilisk, Carrion, Graviton, Kestrel\n        "]))),
    answerType: 'Text'
  }],
  stage: {
    id: '234',
    __typename: 'QuestionsStage',
    challenge: challenges[4]
  },
  currentUserLike: null,
  likes: {
    totalCount: 0
  }
}, {
  __typename: 'PublicResponse',
  id: '6',
  member: member678,
  createdAt: '2022-04-07T14:21:47.473Z',
  responses: [{
    question: {
      html: 'file without preview',
      text: 'file without preview'
    },
    answer: 'https://cdn.filestackcontent.com/jeQb3BelSZSvY85QppiQ',
    answerType: 'File'
  }, {
    question: {
      html: 'file preview',
      text: 'file preview'
    },
    answer: 'https://cdn.filestackcontent.com/uFRJrYUsTRC8sLhzl126#consent_hubs.txt',
    answerType: 'File'
  }, {
    question: {
      html: 'Who is your favourite villian?',
      text: 'Who is your favourite villian?'
    },
    answer: 'The Joker is the best!',
    answerType: 'RawVideo'
  }, {
    question: {
      html: 'Who is you least favourite superhero?',
      text: 'Who is you least favourite superhero?'
    },
    answer: 'https://static.influitives.com/files/cec92905-a3ba-403d-b75b-69679010f9e6/1215/converted/79u1e5HmQ6usObkfJLL2_file_example_AVI_480_750kB.mp4',
    answerType: 'BrokenVideo'
  }, {
    question: {
      html: 'Who is you least favourite superhero?',
      text: 'Who is you least favourite superhero?'
    },
    answer: 'https://static.influitives.com/files/cec92905-a3ba-403d-b75b-69679010f9e6/1215/converted/79u1e5HmQ6usObkfJLL2_file_example_AVI_480_750kB.mp4',
    answerType: 'ConvertedVideo'
  }],
  stage: {
    id: '789',
    __typename: 'QuestionsStage',
    challenge: challenges[5]
  },
  currentUserLike: null,
  likes: {
    totalCount: 0
  }
}];